import { useExampleService } from "services/example";
import { usePostsStore } from "store/postsStore";
const delay = (ms) => new Promise((res) => setTimeout(res, ms));

export const usePostsExample = () => {
  const { getListExample } = useExampleService();
const {setIsLoading, setPosts, setError, posts, error, isLoading, clear } = usePostsStore()

  const fetchAllPosts = async () => {
    try {
      setIsLoading(true);
      await delay(2000);
      if(Math.random() < 0.5) {
        throw Error("errorExample")
      }
      const data = await getListExample();
      setPosts(data);
    } catch (error) {
      setError(error.toString());
    } finally {
      setIsLoading(false);
    }
  };

  return {
    posts,
    error,
    clear,
    setPosts,
    isLoading,
    setIsLoading,
    fetchAllPosts,
  };
};
